import { render, staticRenderFns } from "./ClassesTable.vue?vue&type=template&id=295bba61&scoped=true&"
import script from "./ClassesTable.vue?vue&type=script&lang=js&"
export * from "./ClassesTable.vue?vue&type=script&lang=js&"
import style0 from "./ClassesTable.vue?vue&type=style&index=0&id=295bba61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295bba61",
  null
  
)

export default component.exports